////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import styled from 'styled-components'
///////COMPONENTS///////
import { fr } from 'date-fns/locale'
import '../../../../theme/DatePickerStyle/react-datepicker.css'
/////////ASSETS/////////
import theme from '../../../../theme/theme'
import imgValidate from '../../../../assets/icones/global/check.svg'
import imgCancel from '../../../../assets/icones/global/close-white.svg'
import Modals from '../../../../components/Modals'

/////////STYLED/////////
const DatePickerWrapper = styled.div``
const ModalDateTimeWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	& > * {
		font-size: ${(props) => props.theme.font.fm} !important;
	}
`
const CalendarsWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	margin-top: ${(props) => (props.marginTop ? '20px' : '0')};
	height: ${(props) => (props.height ? props.height + 'px' : 'inherit')};
	& * {
		font-size: ${(props) => props.theme.font.fs} !important;
	}
	& .react-datepicker__day--keyboard-selected {
		background-color: ${(props) => (props.firstDate ? null : props.theme.colors.datePickerBg)};
		color: ${(props) => (props.firstDate ? null : props.theme.colors.black)};
		border: 1px solid ${(props) => (props.firstDate ? null : props.theme.colors.primary)};
		font-weight: 400;
	}
	& div.react-datepicker__week > div:focus {
		outline: none;
	}
	& .react-datepicker__day-name,
	& .react-datepicker__day,
	& .react-datepicker__time-name {
		width: 33px !important;
		height: 33px !important;
		border-radius: 0px !important;
	}
`
const InputsWrapper = styled.div`
	width: auto;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 11px;
	font-size: 16px;
`
const PaireInputWrapper = styled.div`
	display: flex;
	width: 231px;
	justify-content: flex-start;
	z-index: 2;
`
const InputStyle = styled.div`
	line-height: 32px;
	padding: 0px 10px;
	border: 1px solid ${(props) => props.theme.colors.datePicker.borderInput};
	border-radius: 3px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: ${(props) => props.theme.font.fm};
	width: 90px;
`
const TextAndInputWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	/* borders for inputs and datepicker inputs */
	& > div > div > input {
		border: 1px solid ${(props) => props.theme.colors.datePicker.borderInput};
	}
	& > div > div > div > input {
		border: 1px solid ${(props) => props.theme.colors.datePicker.borderInput};
	}
	& .react-datepicker__input-container {
		line-height: normal;
	}
	& .react-datepicker__input-container > input {
		height: auto;
		line-height: 32px;
		padding: 0px 10px;
		width: 90px;
	}
	& .react-datepicker-time__header {
		font-size: ${(props) => props.theme.font.fs};
	}
	& .react-datepicker--time-only .react-datepicker__time-container {
		font-size: ${(props) => props.theme.font.fs} !important;
		width: 110px;
	}
`
const TextBelowInput = styled.p`
	color: ${(props) => props.theme.colors.tabText};
	margin: 0;
	padding-bottom: 5px;
	font-weight: bold;
`
const ButtonBottm = styled.div`
	text-align: center;
	border-radius: 3px;
	margin-right: ${(props) => (props.margin ? `${props.margin}px` : '0')};
	color: white;
	font-weight: bold;
	line-height: 32px;
	padding: 0px 11px;
	background-color: ${(props) => (props.disabled ? props.theme.colors.grey : props.bcg)};
	opacity: ${(props) => (props.disabled ? 0.5 : 1)};
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	:hover {
		background-color: ${(props) => props.hover};
	}
	transition: background-color 0.1s;
	& > img {
		height: 10px;
	}
`
const BottomButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	height: 32px;
	position: relative;
	& .validate {
		padding: 0px 9px;
		margin-right: 0px;
	}

	margin: 0px 8px;
`
/////////STYLED/////////

const ArticleDatePicker = ({
	showModal,
	date,
	handleValidate,
	handleClose,
	handleChangeDate,
	title,
	postLimit = false,
	priorLimit = false,
	insideModal = false,
}) => {
	const [windowPageYOffset, setWindowPageYOffset] = useState(0)
	const [windowPageXOffset, setWindowPageXOffset] = useState(0)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const openDateModalHandler = () => {
		setWindowPageYOffset(window.pageYOffset)
		setWindowPageXOffset(window.pageXOffset)

		window.addEventListener('scroll', onScrollHandler)
	}

	const closeDateModalHandler = () => {
		window.removeEventListener('scroll', onScrollHandler)
	}

	const onScrollHandler = () => {
		if (showModal) {
			window.scrollTo(windowPageXOffset, windowPageYOffset)
		}
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (showModal) {
			openDateModalHandler()
		} else {
			closeDateModalHandler()
		}
	}, [showModal])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<DatePickerWrapper>
			<Modals title={''} closeModalHandler={handleClose} showModal={showModal} insideModal={insideModal}>
				<ModalDateTimeWrapper>
					<InputsWrapper>
						<PaireInputWrapper>
							<TextAndInputWrapper>
								<TextBelowInput>
									{title}
									{/* Date de début */}
								</TextBelowInput>
								<InputStyle>
									{/* Commenting test on priorLimit => if it is setted, date will not change in input */}
									{/*priorLimit ? moment(priorLimit).format('DD-MM-YYYY') :*/ moment(date).format('DD-MM-YYYY')}
								</InputStyle>
							</TextAndInputWrapper>
						</PaireInputWrapper>
					</InputsWrapper>
					<CalendarsWrapper height={272}>
						<DatePicker
							selected={date}
							onChange={handleChangeDate}
							maxDate={postLimit ? new Date(postLimit) : null}
							locale={fr}
							minDate={priorLimit ? new Date(priorLimit) : moment().toDate()}
							inline
						/>
					</CalendarsWrapper>

					<CalendarsWrapper marginTop hasPreset>
						<BottomButtonWrapper>
							<ButtonBottm onClick={handleClose} bcg={theme.colors.error} margin={10} hover={theme.colors.hoverError}>
								<img src={imgCancel} />
							</ButtonBottm>
							<ButtonBottm
								className="validate"
								onClick={handleValidate}
								bcg={theme.colors.validation}
								margin={15}
								hover={theme.colors.hoverValidation}
							>
								<img src={imgValidate} />
							</ButtonBottm>
						</BottomButtonWrapper>
					</CalendarsWrapper>
				</ModalDateTimeWrapper>
			</Modals>
		</DatePickerWrapper>
	)
}

ArticleDatePicker.propTypes = {}

ArticleDatePicker.defaultPropTypes = {}

export default ArticleDatePicker
